export const Platform = {
  IOS: 'ios',
  Android: 'android',
} as const
export type Platform = typeof Platform[keyof typeof Platform]
export const platforms = Object.values(Platform) as string[]
